<script setup>
import { Field, FieldDescription, FieldLabel } from '../../../ui/field/index.js'
import { Input } from '../../../ui/input/index.js'
import { computed } from 'vue'


const modelValue = defineModel({
  type: String,
  default: null
})

import { formFieldProps, useFormField } from '@/composables/fields/useFormField.js'

// 1. Pass the imported object to defineProps
const props = defineProps(formFieldProps)

// 2. Pass the props to the composable to get your logic
const { inputId, isError, isSuccess } = useFormField(props)


</script>

<template>
  <Field>
    <FieldLabel :for="inputId" :is-error="isError" :is-success="isSuccess">
      {{ props.label || 'Email Address' }}
    </FieldLabel>

    <Input :id="inputId" v-model:model-value="modelValue" :is-error="isError" :is-success="isSuccess" :disabled="props.disabled" :placeholder="props.placeholder || ''" />

    <FieldDescription v-if="isError && props.errorMessage" class="text-destructive font-medium">
      {{ props.errorMessage }}
    </FieldDescription>

    <FieldDescription v-else-if="props.description" :class="{ 'text-success font-medium': isSuccess }">
      {{ props.description }}
    </FieldDescription>
  </Field>
</template>

<style scoped>

</style>
